import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'beta.300',
    endColor: 'beta.400',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.600',
    border: 'none',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    color: 'epsilon.100',
    mb: '0',

    _hover: {
      bg: 'blackAlpha.700',
    },

    _focus: {
      color: 'epsilon.200',
      bg: 'blackAlpha.700',
    },
    _active: {
      bg: 'blackAlpha.700',
    },
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
  },
  inputRightIcon: {
    color: 'beta.200',
    boxSize: '5',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
  },
  accordionButtonText: {
    fontSize: ['sm', 'lg'],
    textShadow: '0px 4px 3px rgba(0, 0, 0, 0.15)',
    color: 'epsilon.100',
    fontFamily: ' CreteRound',
    fontWeight: 'normal',
    textTransform: 'capitalize',
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  accordionButtonIconSvg: {
    color: 'alpha.100',
    fontSize: 'sm',
  },
  flex: { alignItems: 'center', gap: 1.5, flex: 1, textAlign: 'left' },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: 'xs',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'beta.200',
  },
  accordionPanel: {
    p: '0',
    mb: '2',
  },
};
